module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [(_vm.isGoogle) ? _c('form', {
    attrs: {
      "method": "get",
      "action": "https://www.google.com/search",
      "target": "_blank"
    }
  }, [_c('input', {
    staticClass: "search-text",
    attrs: {
      "type": "text",
      "name": "q"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "search-button",
    attrs: {
      "type": "submit",
      "value": "搜索"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e3cf60d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
// module id = 76
// module chunks = 1